module.exports = __webpack_public_path__ + "img/role.d3ef4b61.jpg";